import { Flex, Text } from '@chakra-ui/react';
import { Icon } from 'src/components/atoms/Icon';

export const DefaultCampaignCell: React.FC<{
  selectedCount: number;
  onClick: () => void;
}> = ({ selectedCount, onClick }) => {
  return (
    <Flex
      border="1px solid"
      borderColor={selectedCount > 0 ? 'icon.green' : 'border.box'}
      borderRadius="4px"
      padding="4px"
      alignItems="center"
      justifyContent="space-between"
      width="full"
      onClick={onClick}
      cursor="pointer">
      <Text color="text.muted" fontSize="sm">
        {selectedCount > 0 ? `${selectedCount} selected` : 'Select'}
      </Text>
      <Icon iconName="chevron-down" />
    </Flex>
  );
};
